import React from 'react'
import CustomFooter from '../components/footer/Footer'
import { useNavigate } from 'react-router-dom'
import { Image } from 'antd';
import myImage from '../assets/images/under_construction.png';
import  { ArrowLeftOutlined } from '@ant-design/icons';
import './UnderConstruction.css'

function UnderConstruction() {
    const navigate = useNavigate();
    return (
        <div style={{flex:1,display:'flex',flexDirection:'column',backgroundColor:'#EEEEEE'}}>
            <div style={{border:'solid 2px',width:'70px',height:'20px',borderColor:'gray',color:'gray',borderRadius:'10%',padding:4,alignItems:'center',justifyContent:'center',alignContent:'center',textAlign:'center',margin:5}} onClick={()=>navigate('/attractions')}>  <ArrowLeftOutlined /> Back </div>
            <div style={{justifyContent:'center',display:'flex',flex:1,alignContent:'center',justifyContent:'center',width:'100%'}}>
                <Image style={{width:'40%',justifyContent:'center',alignItems:'center',alignSelf:'center',display:'flex'}} src={myImage} alt="Description of image" preview={false} />
            </div>
            <CustomFooter />
        </div>
    )
}

export default UnderConstruction